import script from "./ContactUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactUs.vue?vue&type=script&lang=ts&setup=true"

import "./ContactUs.vue?vue&type=style&index=0&id=ab288520&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab288520"]])

export default __exports__